export default __webpack_public_path__ + "static/media/icon_dev.60f0aebc.svg";